export default __webpack_public_path__ + "static/media/compass.d03702e2.svg";